import { useEffect, useState } from "react";
import { SearchContext } from "../useSearchContext";

export function useCheckpoint({
  aggregations,
  eventsList,
  entitiesList,
}: Pick<SearchContext, "aggregations" | "eventsList" | "entitiesList">) {
  const [checkpoint, setSerializedCheckpoint] = useState(
    aggregations.serialized ||
      eventsList.serialized ||
      entitiesList.serialized ||
      ""
  );
  useEffect(() => {
    setSerializedCheckpoint(aggregations.serialized);
  }, [aggregations.serialized]);
  useEffect(() => {
    setSerializedCheckpoint(eventsList.serialized);
  }, [eventsList.serialized]);
  useEffect(() => {
    setSerializedCheckpoint(entitiesList.serialized);
  }, [entitiesList.serialized]);
  return checkpoint;
}
